export default __webpack_public_path__ + "cd6807f70cc46547da23d714afff1706.png";